<template>
  <wc-dialog
    title='Hold invoices'
    :icon='$icons.hold.icon'
    iconColor='error'
    :showDialog='showDialog'
    @cancel='closeDialog'
    @save='updateHold'
    :disableButtons='!isFormValid'
  >
    <v-form v-model='isFormValid' ref='form'>
      <v-checkbox
        readonly
        label='Put on hold?'
        v-model='invoice.is_on_hold'
        :hint="invoice.is_on_hold ? 'Remove hold reason to uncheck' : 'Add reason to put on hold'"
        persistent-hint
      ></v-checkbox>
      <br>
      <v-textarea
        label='Hold reason'
        outlined
        v-model='invoice.hold_reason'
        @input='checkHoldReason'
      ></v-textarea>
    </v-form>
  </wc-dialog>
</template>

<script>
import trackerAPI from '@/api/tracker';
import formRules from '@/mixins/formRules';
import moment from 'moment';

export default {
  name: 'invoice-hold-dialog',
  mixins: [formRules],
  props: {
    showDialog: {
      required: true
    },
    invoice: {
      required: true
    }
  },
  data: () => ({
    isFormValid: false
  }),
  methods: {
    closeDialog () {
      this.$emit('closeDialog');
    },
    async updateHold () {
      const description = this.invoice.is_on_hold ? 'INVOICE PUT ON HOLD: ' + this.invoice.hold_reason : 'Removed invoice hold';
      const tracker_data = {
            'description': description,
            'taken_by': this.$store.state.auth.profile.id,
            'action_date': moment().format('YYYY-MM-DD').toString()
        }
        const tracker = {
            'tracker_data': tracker_data,
            'invoice': this.invoice.id
        }
      const res = await trackerAPI.createInvoiceTracker(tracker);
      this.$emit('newAction', res);
      this.$emit('updateHold', {
        "is_on_hold": this.invoice.is_on_hold,
        "hold_reason": this.invoice.hold_reason
        })
    },
    checkHoldReason () {
      this.invoice.is_on_hold = this.invoice.hold_reason ? true : false;
    }
  }
}
</script>
